import { Mesh, Object3D } from "three";
import { GLBModel } from "./GLBModel";

export class GLBMorphTargetModel extends GLBModel {
  constructor(
    path: string,
    private readonly keyOverride: string,
    private readonly morphWeights: readonly number[]
  ) {
    super(path);
  }

  override get key(): string {
    return this.keyOverride;
  }

  override getModel(): Object3D | null {
    const object = super.getModel();
    if (!object) return null;

    object.traverse((child) => {
      if (!(child instanceof Mesh) || !child.morphTargetInfluences) return;

      child.morphTargetInfluences.forEach((_, index, influences) => {
        influences[index] = this.morphWeights[index] ?? 0;
      });
    });

    return object;
  }
}
